import find from './find.js';
import matcher from './matcher.js';

// Convenience version of a common use case of `_.find`: getting the first
// object containing specific `key:value` pairs.
export default function findWhere(obj, attrs) {
  return find(obj, matcher(attrs));
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/findWhere.js
// module id = 1320
// module chunks = 9